import { Component, inject, input, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { jkLib, JkBaseComponent, JknumbereditComponent, JkcheckboxComponent, JktextareaComponent, GoogleSpeechService } from 'jk-service';
import { Subject, interval, takeUntil } from 'rxjs';
import { AudioService, mp3_pristine } from 'jk-service';
import { CR } from 'jk-service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-tomato-timer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, JknumbereditComponent,
    JkcheckboxComponent, JktextareaComponent,
  ],
  templateUrl: './tomato-timer.component.html',
  styleUrl: './tomato-timer.component.scss'
})
export class TomatoTimerComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'tomato-timer';
  @Input() googleApiKey: string = '';
  dialogData: any = inject(MAT_DIALOG_DATA);//inject(MAT_DIALOG_DATA, { optional: true });  //@Input() azureEnv!:AzureEnvironment;
  // Convert @Input() to input() signals
  //azureEnv = input<AzureEnvironment>();

  // Services injected using inject()
  //tts: AzureTtsService = inject(AzureTtsService);

  // Component properties
  waitMin: number = 25;
  second: number = 0;

  get remainTime(): string {
    let mm = Math.floor(this.second / 60);
    let ss = this.second % 60;
    return mm + '分' + ss + '秒';
  }

  restMin: number = 5;
  overSec: number = 0;
  minute: number = 0;
  isWorking: boolean = false;
  buttonDisabled: boolean = false;
  stop$: any;
  log: string = '';

  get gaugeAppend(): string {
    return this.waitMin + '分鐘';
  }

  constructor(public tts: GoogleSpeechService) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    const apiKey = this.dialogData?.googleApiKey ?? this.googleApiKey;
    this.tts.setApiKey(apiKey);
    this.doSeccondTimer();
  }

  addLog(msg: string) {
    this.log = this.log + jkLib.nowTime8() + ' ' + msg + CR;
  }

  doSeccondTimer() {
    const timer1 = interval(1000);
    const result = timer1
      .pipe()
      .subscribe((e) => {
        if (this.second > 0) {
          this.second = this.second - 1;
        }
        // 手動觸發變更檢測以符合 zoneless 模式
        this.cdr.markForCheck();
      });
  }

  mySpeakText(msg: string) {
    //this.tts.speakText(this.azureEnv()!,msg, 'zh-TW-YunJheNeural');
    this.tts.textToSpeech(msg).subscribe({
      next: (result) => this.playAudio(result),
      error: (err) => console.error('Error during TTS:', err)
    });
  }


  startTimer(minute: number, isWork: boolean) {
    this.isWorking = isWork;
    if (this.isWorking) {
      this.waitMin = minute;
    } else {
      this.restMin = minute;
    }
    this.minute = minute;
    this.second = this.minute * 60;
    this.buttonDisabled = true;
    let msg = '計時' + minute + '分鐘';
    this.addLog(msg);
    this.mySpeakText(msg);
    const audio = new AudioService();
    audio.play(mp3_pristine);
    this.stop$ = new Subject();
    const countdown$ = interval(1000 * 60).pipe(takeUntil(this.stop$));

    countdown$.subscribe((count) => {
      this.minute = minute - count - 1;
      if (this.minute === 0) {
        let msg = '時間到了';
        this.addLog(msg);
        this.mySpeakText(msg);
        const audio = new AudioService();
        audio.play(mp3_pristine);

        this.stop$.next(0);
        this.stop$.complete();
        this.buttonDisabled = false;
        if (isWork) {
          this.promptRest();
        }
      }
      // 手動觸發變更檢測以符合 zoneless 模式
      this.cdr.markForCheck();
    });
  }

  promptRest() {
    setTimeout(() => {
      if (this.isWorking && (this.minute === 0)) {
        const audio = new AudioService();
        audio.play(mp3_pristine);
        let msg = '休息時間到了';
        this.addLog(msg);
        this.mySpeakText(msg);
        this.promptRest();
      } else {
        console.log('休息時間結束');
      }
      this.cdr.markForCheck();
    }, 1000 * 15);
  }

  resetTimer() {
    this.isWorking = false;
    this.minute = 0;
    this.buttonDisabled = false;
    this.stop$.next();
    this.stop$.complete();
    let msg = '時間歸零';
    this.addLog(msg);
    this.mySpeakText(msg);
  }
}

